export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname:'div', 
              name: "Div",
              attributes: { class: 'events-container' },
              components: [      
                {
                  type:'rowEvents1',
                },
                {
                  type:'rowEvents1',
                },
              ],
              styles: `
               .events-container{
                display: flex; 
                flex-direction:column;
                gap:16px; 
                margin-top:50px;
               }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};